import $ from 'jquery';

export default class StaticFooter {
  constructor() {
    this.$body = $(document.body);
    this.viewportClass = 'viewport-bottom';

    $(window).on('scroll', this._scrollBottom.bind(this));

    this._isBottom();
  }

  _isBottom() {
    if ($(window).scrollTop() + $(window).height() >= $(document).height() - 55) {
      $(this.$body).addClass(this.viewportClass);
    }
  }

  _scrollBottom() {
    $(this.$body).removeClass(this.viewportClass);
    this._isBottom();
  }
}